var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServicePageLayout',{attrs:{"title":"Fire Alarm Report","subtitle":"รายงานระบบแจ้งเหตุเพลิงไหม้","icon":"mdi-chart-box-outline","icon-color":"error","breadcrumb":"Reports"}},[_c('FireAlarmReportFilter'),_c('FireAlarmReportDataTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }